/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Border_RadiusInputs */

const fr_label_border_radius = /** @type {(inputs: Label_Border_RadiusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Border radius`)
};

const en_label_border_radius = /** @type {(inputs: Label_Border_RadiusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Border radius`)
};

/**
* | output |
* | --- |
* | "Border radius" |
*
* @param {Label_Border_RadiusInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_border_radius = /** @type {((inputs?: Label_Border_RadiusInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Border_RadiusInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_border_radius(inputs)
	return en_label_border_radius(inputs)
});